
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
import { useFormContext } from 'react-hook-form';

interface StatusFieldProps {
  showRejectionReason: boolean;
}

export const StatusField: React.FC<StatusFieldProps> = ({ showRejectionReason }) => {
  const { control } = useFormContext();

  return (
    <>
      <FormField
        control={control}
        name="status"
        render={({ field }) => (
          <FormItem>
            <FormLabel>สถานะรายงาน</FormLabel>
            <Select
              onValueChange={field.onChange}
              defaultValue={field.value}
              value={field.value}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="เลือกสถานะรายงาน" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="PENDING">รอการตรวจสอบ</SelectItem>
                <SelectItem value="APPROVED">อนุมัติแล้ว</SelectItem>
                <SelectItem value="REJECTED">ไม่อนุมัติ</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      {showRejectionReason && (
        <FormField
          control={control}
          name="rejection_reason"
          render={({ field }) => (
            <FormItem>
              <FormLabel>เหตุผลที่ไม่อนุมัติ</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="ระบุเหตุผลที่ไม่อนุมัติรายงาน"
                  {...field}
                  value={field.value || ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </>
  );
};
